import { BNB_ADDRESS } from './constants'

const MIN_VALUE_DISPLAYED = 0.001

export const getTimeWindowChange = (lineChartData) => {
  if (lineChartData.length > 0) {
    const firstValue = lineChartData.find(({ value }) => !!value && value > 0)?.value ?? 0
    const lastValue = lineChartData[lineChartData.length - 1].value
    const changeValue = lastValue - firstValue

    return {
      changeValue:
        changeValue > 0 ? Math.max(changeValue, MIN_VALUE_DISPLAYED) : Math.min(changeValue, MIN_VALUE_DISPLAYED * -1),
      changePercentage: ((changeValue / firstValue) * 100).toFixed(2),
    }
  }

  return {
    changeValue: 0,
    changePercentage: 0,
  }
}

export const getTokenAddress = (tokenAddress: undefined | string) => {
  console.log('[Chart Utils] getTokenAddress called with:', tokenAddress)
  
  if (!tokenAddress) {
    console.log('[Chart Utils] No token address provided, returning empty string')
    return ''
  }
  
  const lowerCaseAddress = tokenAddress.toLowerCase()
  console.log('[Chart Utils] Lowercase address:', lowerCaseAddress)
  
  // Handle native currency symbols - map to their wrapped token addresses for chart data
  if (lowerCaseAddress === 'bnb') {
    console.log('[Chart Utils] BNB detected, returning BNB_ADDRESS:', BNB_ADDRESS)
    return BNB_ADDRESS
  }
  
  if (lowerCaseAddress === 'grx') {
    const wgrxAddress = '0x45C7287F897B3A79Cd3f6e4F14B4CE568f023bD5'
    console.log('[Chart Utils] GRX detected, mapping to WGRX address:', wgrxAddress)
    return wgrxAddress
  }

  console.log('[Chart Utils] Returning original address:', lowerCaseAddress)
  return lowerCaseAddress
}
